import { SVGProps } from 'react';

export const Camera = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 6.00342C7.794 6.00342 6 7.79742 6 10.0034C6 12.2094 7.794 14.0034 10 14.0034C12.206 14.0034 14 12.2094 14 10.0034C14 7.79742 12.206 6.00342 10 6.00342Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 16.0034C6.691 16.0034 4 13.3124 4 10.0034C4 6.69542 6.691 4.00342 10 4.00342C13.309 4.00342 16 6.69542 16 10.0034C16 13.3124 13.309 16.0034 10 16.0034ZM18 3.00342H16.07C15.402 3.00342 14.777 2.66942 14.406 2.11342L13.594 0.893418C13.223 0.337418 12.598 0.00341797 11.93 0.00341797H8.07C7.402 0.00341797 6.777 0.337418 6.406 0.893418L5.594 2.11342C5.223 2.66942 4.598 3.00342 3.93 3.00342H2C0.895 3.00342 0 3.89942 0 5.00342V16.0034C0 17.1074 0.895 18.0034 2 18.0034H18C19.104 18.0034 20 17.1074 20 16.0034V5.00342C20 3.89942 19.104 3.00342 18 3.00342Z"
      fill="currentColor"
    />
  </svg>
);
